import {
    TerminateActivePurchasedProductRequestInterface,
    TerminateActivePurchasedProductResponseInterface,
    ApiTerminateActivePurchasedProductRequest,
    ApiTerminateActivePurchasedProductResponse
} from '../interfaces';

/** @deprecated use OutInsurancePolicyModule store */
export function mapTerminateActivePurchasedProductRequest(
    request: TerminateActivePurchasedProductRequestInterface
): ApiTerminateActivePurchasedProductRequest {
    return {
        purchased_product_sequence_number: request.purchasedProductSequenceNumber,
        end_date: request.endDate,
        reason_code: request.reasonCode
    };
}

/** @deprecated use OutInsurancePolicyModule store */
export function mapTerminateActivePurchasedProductResponse(
    response: ApiTerminateActivePurchasedProductResponse
): TerminateActivePurchasedProductResponseInterface {
    return {
        success: response.success,
        terminationQuestions: response.termination_questions.map((question) => ({
            questionElementId: question.question_element_id,
            questionDescription: question.question_description,
            order: question.order,
            formatCode: question.format_code,
            formatDescription: question.format_description,
            answers: question.answers.map((answer) => ({
                answerCode: answer.answer_code,
                answerDescription: answer.answer_description,
            })),
        })),
    };
}
